import React, { useState, useMemo, useRef } from "react";
import skills from "./skills.json"
interface SkillDropdownProps {

    onSelect: (skill: string, selectedSkills: string[], setSelectedSkills: React.Dispatch<React.SetStateAction<string[]>>) => void;
    skillSet: string[];
    setSkillSet: React.Dispatch<React.SetStateAction<string[]>>
}

const SkillDropdown: React.FC<SkillDropdownProps> = ({ onSelect, skillSet, setSkillSet }) => {
    const [query, setQuery] = useState("");
    const [activeIndex, setActiveIndex] = useState(-1);
    const inputRef = useRef<HTMLInputElement>(null);

    const filteredSkills = useMemo(() => {
        if (!query) return [];
        const filtered = skills.filter((skill) =>
            skill.toLowerCase().includes(query.toLowerCase())
        );
        // Add the current query if it's not in the filtered results and not empty
        if (query.trim() && !filtered.includes(query.trim())) {
            return [query.trim(), ...filtered];
        }
        return filtered;
    }, [query, skills]);

    const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
        if (e.key === "ArrowDown") {
            setActiveIndex((prev) =>
                Math.min(prev + 1, filteredSkills.length - 1)
            );
        } else if (e.key === "ArrowUp") {
            setActiveIndex((prev) => Math.max(prev - 1, 0));
        } else if (e.key === "Enter" || e.key === ",") {
            e.preventDefault();
            if (e.key === "," || e.key === "Enter") {
                const skillsToAdd = query.split(",").map(skill => skill.trim()).filter(skill => skill !== "");
                if (skillsToAdd.length > 0) {
                    skillsToAdd.forEach(skill => {
                        onSelect(skill, skillSet, setSkillSet);
                    });
                }
                setQuery("");
                setActiveIndex(-1);
            }
        }
    };

    const handleClick = (skill: string) => {
        onSelect(skill, skillSet, setSkillSet);
        setQuery("");
        setActiveIndex(-1);
        inputRef.current?.focus();
    };

    return (
        <div className="relative w-full ">
            <input
                ref={inputRef}
                type="text"
                placeholder="Type a skill and press Enter, or click to select from suggestions"
                className="w-full border border-gray-300 rounded px-4 py-2 "
                value={query}
                onChange={(e) => {
                    setQuery(e.target.value);
                    setActiveIndex(-1);
                }}
                onKeyDown={handleKeyDown}
            />

            {query && filteredSkills.length > 0 && (
                <ul className="absolute z-10 bg-white border border-gray-200 rounded mt-1 max-h-60 overflow-y-auto shadow-md w-full">
                    {filteredSkills.slice(0, 20).map((skill, i) => (
                        <li
                            key={skill}
                            className={`px-4 py-2 cursor-pointer ${i === activeIndex ? "bg-blue-100" : "hover:bg-gray-100"
                                }`}
                            onMouseDown={() => handleClick(skill)}
                        >
                            {skill}
                        </li>
                    ))}
                </ul>
            )}
        </div>
    );
};

export default SkillDropdown;
